import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeView, MenuProjectId } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckUserMenuAccess, ApiGetProjectById } from "utils/constants/api";
import { GetStatus, money, RoundTwoDecimals } from "utils/helpers";
import moment from "moment";
import ChevronRightIcon from "assets/icon/ChevronRightIcon";
import ChevronDownIcon from "assets/icon/ChevronDownIcon";

export default function ProjectView(){
    let navigate = useNavigate()
    
    const{ fetch: getProjectById } = useFetch(ApiGetProjectById)
    const{ fetch: checkAccess } = useFetch(ApiCheckUserMenuAccess)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramProjectId = queryString.get("projectId")

    const [clientName, setClientName] = useState(EmptyString)
    const [marketingName, setMarketingName] = useState(EmptyString)
    const [projectLocation, setProjectLocation] = useState(EmptyString)
    const [subConName, setSubConName] = useState(EmptyString)
    const [comfee, setComfee] = useState(EmptyString)
    const [termin1, setTermin1] = useState(EmptyString)
    const [termin2, setTermin2] = useState(EmptyString)
    const [termin3, setTermin3] = useState(EmptyString)
    const [termin4, setTermin4] = useState(EmptyString)
    const [termin5, setTermin5] = useState(EmptyString)

    const [terminSubCon1, setTerminSubCon1] = useState(EmptyString)
    const [terminSubCon2, setTerminSubCon2] = useState(EmptyString)
    const [terminSubCon3, setTerminSubCon3] = useState(EmptyString)
    const [terminSubCon4, setTerminSubCon4] = useState(EmptyString)
    const [terminSubCon5, setTerminSubCon5] = useState(EmptyString)
    
    const [status, setStatus] = useState(EmptyString)
    const [statusCode, setStatusCode] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    // Furniture
    const [furSalesPrice, setFurSalesPrice] = useState(EmptyString)
    const [furHpp, setFurHpp] = useState(EmptyString)
    const [furOperational, setFurOperational] = useState(EmptyString)
    const [furInsurance, setFurInsurance] = useState(EmptyString)
    const [furMarketingCommission, setFurMarketingCommission] = useState(EmptyString)
    const [furDesigner, setFurDesigner] = useState(EmptyString)
    const [furDrafter, setFurDrafter] = useState(EmptyString)
    const [furTax, setFurTax] = useState(EmptyString)
    const [furProfit, setFurProfit] = useState(EmptyString)
    
    // Civil
    const [civSalesPrice, setCivSalesPrice] = useState(EmptyString)
    const [civHpp, setCivHpp] = useState(EmptyString)
    const [civOutMarketing, setCivOutMarketing] = useState(EmptyString)
    const [civInMarketing, setCivInMarketing] = useState(EmptyString)
    const [civDiscount, setCivDiscount] = useState(EmptyString)
    const [civInsurance, setCivInsurance] = useState(EmptyString)
    const [civMarketingCommission, setCivMarketingCommission] = useState(EmptyString)
    const [civDesigner, setCivDesigner] = useState(EmptyString)
    const [civDrafter, setCivDrafter] = useState(EmptyString)
    const [civTax, setCivTax] = useState(EmptyString)
    const [civProfit, setCivProfit] = useState(EmptyString)

    // Electrical
    const [elSalesPrice, setElSalesPrice] = useState(EmptyString)
    const [elHpp, setElHpp] = useState(EmptyString)
    const [elOutMarketing, setElOutMarketing] = useState(EmptyString)
    const [elInMarketing, setElInMarketing] = useState(EmptyString)
    const [elDiscount, setElDiscount] = useState(EmptyString)
    const [elDesigner, setElDesigner] = useState(EmptyString)
    const [elDrafter, setElDrafter] = useState(EmptyString)
    const [elTax, setElTax] = useState(EmptyString)
    const [elProfit, setElProfit] = useState(EmptyString)

    // Electronic
    const [electronicSalesPrice, setElectronicSalesPrice] = useState(EmptyString)
    const [electronicHpp, setElectronicHpp] = useState(EmptyString)
    const [electronicInMarketing, setElectronicInMarketing] = useState(EmptyString)
    const [electronicDiscount, setElectronicDiscount] = useState(EmptyString)
    const [electronicDesigner, setElectronicDesigner] = useState(EmptyString)
    const [electronicOthers, setElectronicOthers] = useState(EmptyString)
    const [electronicProfit, setElectronicProfit] = useState(EmptyString)

    // Accesscories
    const [accSalesPrice, setAccSalesPrice] = useState(EmptyString)
    const [accHpp, setAccHpp] = useState(EmptyString)
    const [accOutMarketing, setAccOutMarketing] = useState(EmptyString)
    const [accInMarketing, setAccInMarketing] = useState(EmptyString)
    const [accDiscount, setAccDiscount] = useState(EmptyString)
    const [accDesigner, setAccDesigner] = useState(EmptyString)
    const [accDrafter, setAccDrafter] = useState(EmptyString)
    const [accOthers, setAccOthers] = useState(EmptyString)
    const [accProfit, setAccProfit] = useState(EmptyString)

    const [showFurniture, setShowFurniture] = useState(true)
    const [showCivil, setShowCivil] = useState(true)
    const [showElectrical, setShowElectrical] = useState(true)
    const [showElectronic, setShowElectronic] = useState(true)
    const [showAccessories, setShowAccessories] = useState(true)


    const furnitureClick = () => {
        setShowFurniture(!showFurniture)
    }
    const civilClick = () => {
        setShowCivil(!showCivil)
    }
    const electricalClick = () => {
        setShowElectrical(!showElectrical)
    }
    const electronicClick = () => {
        setShowElectronic(!showElectronic)
    }
    const accessoriesClick = () => {
        setShowAccessories(!showAccessories)
    }

    const calculateTotalSales = () => {
        let furniture = furSalesPrice === EmptyString ? 0 : parseInt(furSalesPrice.replaceAll(",", ""))
        let civil = civSalesPrice === EmptyString ? 0 : parseInt(civSalesPrice.replaceAll(",", ""))
        let electrical = elSalesPrice === EmptyString ? 0 : parseInt(elSalesPrice.replaceAll(",", ""))
        let electronics = electronicSalesPrice === EmptyString ? 0 : parseInt(electronicSalesPrice.replaceAll(",", ""))
        let accessories = accSalesPrice === EmptyString ? 0 : parseInt(accSalesPrice.replaceAll(",", ""))
        
        let totalSales = furniture + civil + electrical + electronics + accessories

        return totalSales
    }

    const calculateTotalProfit = () => {
        let furniture = furProfit === EmptyString ? 0 : parseInt(furProfit.replaceAll(",", ""))
        let civil = civProfit === EmptyString ? 0 : parseInt(civProfit.replaceAll(",", ""))
        let electrical = elProfit === EmptyString ? 0 : parseInt(elProfit.replaceAll(",", ""))
        let electronics = electronicProfit === EmptyString ? 0 : parseInt(electronicProfit.replaceAll(",", ""))
        let accessories = accProfit === EmptyString ? 0 : parseInt(accProfit.replaceAll(",", ""))
        
        let totalProfit = furniture + civil + electrical + electronics + accessories

        return totalProfit
    }
    const calculateMargin = () => {
        let profit = calculateTotalProfit()
        let sales = calculateTotalSales()

        let margin = profit / sales * 100

        return margin
    }
    const calculateMarginFurniture = () => {
        let salesPrice = furSalesPrice === EmptyString ? 0 : parseFloat(furSalesPrice.replaceAll(",", ""))
        let profit = furProfit === EmptyString ? 0 : parseFloat(furProfit.replaceAll(",", ""))

        let margin = profit / salesPrice * 100

        if (isNaN(margin)){
            margin = 0
        }

        return margin
    }
    const calculateMarginCivil = () => {
        let salesPrice = civSalesPrice === EmptyString ? 0 : parseFloat(civSalesPrice.replaceAll(",", ""))
        let profit = civProfit === EmptyString ? 0 : parseFloat(civProfit.replaceAll(",", ""))

        let margin = profit / salesPrice * 100
        
        if (isNaN(margin)){
            margin = 0
        }

        return margin
    }
    
    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const backBtnClick = () => {
        navigate(-1)
    }

    useEffect(() => {
        setLoading({isOpen: true})
        fCheckUserAccess(localStorage.getItem("Id"), MenuProjectId, localStorage.getItem("CompanyId")).then((res) => {
            if(!res.access){
                navigate("/access-denied")
            }
            if(formType === FormTypeView){
                if(res.view){
                    setLoading({isOpen: true})
                
                    fGetProjectById(paramProjectId).then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    navigate("/access-denied")
                }
            }else{
                navigate("/page-not-found")
            }
        })
    }, [])

    // Function Api Call
    async function fGetProjectById(paramProjectId){
        await getProjectById({
            data: {
                projectId: parseInt(paramProjectId)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                
                setClientName(data.project.clientName)
                setMarketingName(data.project.marketingName)
                setProjectLocation(data.project.projectLocation)
                setSubConName(data.project.subConName)
                setTermin1(data.project.termin1)
                setTermin2(data.project.termin2)
                setTermin3(data.project.termin3)
                setTermin4(data.project.termin4)
                setTermin5(data.project.termin5)

                setTerminSubCon1(data.project.terminSubCon1)
                setTerminSubCon2(data.project.terminSubCon2)
                setTerminSubCon3(data.project.terminSubCon3)
                setTerminSubCon4(data.project.terminSubCon4)
                setTerminSubCon5(data.project.terminSubCon5)
                setComfee(money(String(data.project.comfee)))

                setFurSalesPrice(money(String(data.projectFurniture.furnitureSellingPrice)))
                setFurHpp(money(String(data.projectFurniture.hppDhowi)))
                setFurOperational(money(String(data.projectFurniture.workerOperational)))
                setFurInsurance(money(String(data.projectFurniture.insurance)))
                setFurMarketingCommission(money(String(data.projectFurniture.marketingCommission)))
                setFurDesigner(money(String(data.projectFurniture.designer)))
                setFurDrafter(money(String(data.projectFurniture.drafter)))
                setFurTax(money(String(data.projectFurniture.tax)))
                setFurProfit(money(String(data.projectFurniture.profit)))

                setCivSalesPrice(money(String(data.projectCivil.civilSellingPrice)))
                setCivHpp(money(String(data.projectCivil.hppDhowi)))
                setCivOutMarketing(money(String(data.projectCivil.externalMarketing)))
                setCivInMarketing(money(String(data.projectCivil.internalMarketing)))
                setCivDiscount(money(String(data.projectCivil.discount)))
                setCivInsurance(money(String(data.projectCivil.insurance)))
                setCivMarketingCommission(money(String(data.projectCivil.marketingCommission)))
                setCivDesigner(money(String(data.projectCivil.designer)))
                setCivDrafter(money(String(data.projectCivil.drafter)))
                setCivTax(money(String(data.projectCivil.tax)))
                setCivProfit(money(String(data.projectCivil.profit)))
                
                setElSalesPrice(money(String(data.projectElectrical.electricalSellingPrice)))
                setElHpp(money(String(data.projectElectrical.hppDhowi)))
                setElOutMarketing(money(String(data.projectElectrical.externalMarketing)))
                setElInMarketing(money(String(data.projectElectrical.internalMarketing)))
                setElDiscount(money(String(data.projectElectrical.discount)))
                setElDesigner(money(String(data.projectElectrical.designer)))
                setElDrafter(money(String(data.projectElectrical.drafter)))
                setElTax(money(String(data.projectElectrical.tax)))
                setElProfit(money(String(data.projectElectrical.profit)))

                setElectronicSalesPrice(money(String(data.projectElectronic.electronicSellingPrice)))
                setElectronicHpp(money(String(data.projectElectronic.buyingPrice)))
                setElectronicInMarketing(money(String(data.projectElectronic.internalMarketing)))
                setElectronicDiscount(money(String(data.projectElectronic.discount)))
                setElectronicDesigner(money(String(data.projectElectronic.designer)))
                setElectronicOthers(money(String(data.projectElectronic.other)))
                setElectronicProfit(money(String(data.projectElectronic.profit)))
                
                setAccSalesPrice(money(String(data.projectAccessories.accessoriesSellingPrice)))
                setAccHpp(money(String(data.projectAccessories.hpp)))
                setAccOutMarketing(money(String(data.projectAccessories.externalMarketing)))
                setAccInMarketing(money(String(data.projectAccessories.internalMarketing)))
                setAccDiscount(money(String(data.projectAccessories.discount)))
                setAccDesigner(money(String(data.projectAccessories.designer)))
                setAccDrafter(money(String(data.projectAccessories.drafter)))
                setAccOthers(money(String(data.projectAccessories.other)))
                setAccProfit(money(String(data.projectAccessories.profit)))

                setStatusCode(data.project.status)
                setStatus(data.project.status)
                setCreateDate(data.project.createdDate)
                setUpdateDate(data.project.updatedDate)
                setUpdateBy(data.project.updatedBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCheckUserAccess(userId, menuId, companyId){     
        let access
        
        await checkAccess({
            data: {
                userId: userId, 
                menuId: menuId,
                companyId: companyId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                access = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                window.location.href = "/login"
            }
        })
        
        return access
    }
    
    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Project Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Client Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Client</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <label>{clientName}</label>
                        </div>
                    </div>
                </div>

                {/* Marketing */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Marketing</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <label>{marketingName}</label>
                        </div>
                    </div>
                </div>

                {/* Project Location */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Project Location</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <label>{projectLocation}</label>
                        </div>
                    </div>
                </div>

                {/* SubCon Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Sub Contractor Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <label>{subConName}</label>
                        </div>
                    </div>
                </div>

                {/* Comfee */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Comfee</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <label>{comfee}</label>
                        </div>
                    </div>
                </div>

                {/* Payment Plan */}
                <div className="w-full mt-5">
                    <span className="font-semibold text-xl">Client Payment Plan</span>
                    <hr />
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 1</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={money(termin1)} disabled={true}/>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 2</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={money(termin2)} disabled={true}/>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 3</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={money(termin3)} disabled={true}/>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 4</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={money(termin4)} disabled={true}/>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 5</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={money(termin5)} disabled={true}/>
                        </div>
                    </div>
                </div>
                {/* Sub Con Payment Plan */}
                <div className="mt-5">
                    <div className="w-full">
                        <span className="font-semibold text-xl">Sub Contractor Payment Plan</span>
                        <hr />
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center">
                    <div className="w-48">
                        <span>Termin 1</span>
                    </div>
                    <div className="px-4 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        <input className="input" value={money(terminSubCon1)} disabled={true}/>
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center">
                    <div className="w-48">
                        <span>Termin 2</span>
                    </div>
                    <div className="px-4 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        <input className="input" value={money(terminSubCon2)} disabled={true}/>
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center">
                    <div className="w-48">
                        <span>Termin 3</span>
                    </div>
                    <div className="px-4 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        <input className="input" value={money(terminSubCon3)} disabled={true}/>
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center">
                    <div className="w-48">
                        <span>Termin 4</span>
                    </div>
                    <div className="px-4 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        <input className="input" value={money(terminSubCon4)} disabled={true}/>
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center">
                    <div className="w-48">
                        <span>Termin 5</span>
                    </div>
                    <div className="px-4 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        <input className="input" value={money(terminSubCon5)} disabled={true}/>
                    </div>
                </div>
                {/* Furniture */}
                <div className="p-4 border rounded bg-white mt-4">
                    <div className="cursor-pointer" onClick={furnitureClick}>
                        <div className="flex justify-between">
                            <span className="font-semibold text-xl">Furniture</span>
                            <ChevronRightIcon className={`w-8 ${showFurniture ? 'hidden' : 'block'}`} />
                            <ChevronDownIcon className={`w-8 ${showFurniture ? 'block' : 'hidden'}`} />
                        </div>
                        
                        <hr className={`${showFurniture ? 'block' : 'hidden'}`} />
                    </div>
                    
                    <div className={`flex flex-col gap-4 mt-4 ${showFurniture ? 'block' : 'hidden'}`}>
                        {/* Furniture Harga Jual */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Harga Jual</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{furSalesPrice}</label>
                                </div>
                            </div>
                        </div>

                        {/* Furniture HPP */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>HPP</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{furHpp}</label>
                                </div>
                            </div>
                        </div>

                        {/* Furniture Operational */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Operational Tukang</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{furOperational}</label>
                                </div>
                            </div>
                        </div>

                        {/* Furniture Insurance */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Insurance</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{furInsurance}</label>
                                </div>
                            </div>
                        </div>

                        {/* Furniture Marketing Commission */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Commission</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{furMarketingCommission}</label>
                                </div>
                            </div>
                        </div>

                        {/* Furniture Designer */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Designer</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{furDesigner}</label>
                                </div>
                            </div>
                        </div>

                        {/* Furniture Drafter */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Drafter</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{furDrafter}</label>
                                </div>
                            </div>
                        </div>

                        {/* Furniture Tax */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Tax</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{furTax}</label>
                                </div>
                            </div>
                        </div>

                        {/* Furniture Profit */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Profit</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{furProfit}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Civil */}
                <div className="p-4 border rounded bg-white mt-4">
                    <div className="cursor-pointer" onClick={civilClick}>
                        <div className="flex justify-between">
                            <span className="font-semibold text-xl">Civil & Electrical</span>
                            <ChevronRightIcon className={`w-8 ${showCivil ? 'hidden' : 'block'}`} />
                            <ChevronDownIcon className={`w-8 ${showCivil ? 'block' : 'hidden'}`} />
                        </div>
                        <hr className={`${showCivil ? 'block' : 'hidden'}`} />
                    </div>
                    
                    <div className={`flex flex-col gap-4 mt-4 ${showCivil ? 'block' : 'hidden'}`}>
                        {/* Civil Harga Jual */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Harga Jual</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civSalesPrice}</label>
                                </div>
                            </div>
                        </div>

                        {/* Civil HPP */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>HPP</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civHpp}</label>
                                </div>
                            </div>
                        </div>

                        {/* Civil Out Marketing */}
                        <div className="hidden">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Luar</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civOutMarketing}</label>
                                </div>
                            </div>
                        </div>

                        {/* Civil In Marketing */}
                        <div className="hidden">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Dalam</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civInMarketing}</label>
                                </div>
                            </div>
                        </div>

                        {/* Civil Discount */}
                        <div className="hidden">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Discount</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civDiscount}</label>
                                </div>
                            </div>
                        </div>

                        {/* Civil Insurance */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Insurance</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civInsurance}</label>
                                </div>
                            </div>
                        </div>

                        {/* Civil Marketing Commission */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Commission</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civMarketingCommission}</label>
                                </div>
                            </div>
                        </div>

                        {/* Civil Designer */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Designer</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civDesigner}</label>
                                </div>
                            </div>
                        </div>

                        {/* Civil Drafter */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Drafter</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civDrafter}</label>
                                </div>
                            </div>
                        </div>

                        {/* Civil Tax */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Tax</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civTax}</label>
                                </div>
                            </div>
                        </div>

                        {/* Civil Profit */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Profit</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{civProfit}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Electrical */}
                <div className="p-4 border rounded bg-white mt-4 hidden">
                    <div className="cursor-pointer" onClick={electricalClick}>
                        <div className="flex justify-between">
                            <span className="font-semibold text-xl">Electrical</span>
                            <ChevronRightIcon className={`w-8 ${showElectrical ? 'hidden' : 'block'}`} />
                            <ChevronDownIcon className={`w-8 ${showElectrical ? 'block' : 'hidden'}`} />
                        </div>
                        <hr className={`${showElectrical ? 'block' : 'hidden'}`} />
                    </div>
                    
                    <div className={`flex flex-col gap-4 mt-4 ${showElectrical ? 'block' : 'hidden'}`}>
                        {/* Electrical Harga Jual */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Harga Jual</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{elSalesPrice}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electrical HPP */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>HPP</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{elHpp}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electrical Out Marketing */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Luar</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{elOutMarketing}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electrical In Marketing */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Dalam</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{elInMarketing}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electrical Discount */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Discount</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{elDiscount}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electrical Designer */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Designer</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{elDesigner}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electrical Drafter */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Drafter</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{elDrafter}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electrical Tax */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Tax</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{elTax}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electrical Profit */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Profit</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{elProfit}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Electronics */}
                <div className="p-4 border rounded bg-white mt-4 hidden">
                    <div className="cursor-pointer" onClick={electronicClick}>
                    <div className="flex justify-between">
                            <span className="font-semibold text-xl">Electronics</span>
                            <ChevronRightIcon className={`w-8 ${showElectronic ? 'hidden' : 'block'}`} />
                            <ChevronDownIcon className={`w-8 ${showElectronic ? 'block' : 'hidden'}`} />
                        </div>
                        <hr className={`${showElectronic ? 'block' : 'hidden'}`} />
                    </div>
                    
                    <div className={`flex flex-col gap-4 mt-4 ${showElectronic ? 'block' : 'hidden'}`}>
                        {/* Electronics Harga Jual */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Harga Jual</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{electronicSalesPrice}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electronics HPP */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>HPP</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{electronicHpp}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electronics In Marketing */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Dalam</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{electronicInMarketing}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electronics Discount */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Discount</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{electronicDiscount}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electronics Designer */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Designer</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{electronicDesigner}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electronics Others */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Lain - lain</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{electronicOthers}</label>
                                </div>
                            </div>
                        </div>

                        {/* Electronics Profit */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Profit</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{electronicProfit}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Accessories */}
                <div className="p-4 border rounded bg-white mt-4 hidden">
                    <div className="cursor-pointer" onClick={accessoriesClick}>
                        <div className="flex justify-between">
                            <span className="font-semibold text-xl">Accessories</span>
                            <ChevronRightIcon className={`w-8 ${showAccessories ? 'hidden' : 'block'}`} />
                            <ChevronDownIcon className={`w-8 ${showAccessories ? 'block' : 'hidden'}`} />
                        </div>
                        <hr className={`${showAccessories ? 'block' : 'hidden'}`} />
                    </div>
                    
                    <div className={`flex flex-col gap-4 mt-4 ${showAccessories ? 'block' : 'hidden'}`}>
                        {/* Accessories Harga Jual */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Harga Jual</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{accSalesPrice}</label>
                                </div>
                            </div>
                        </div>

                        {/* Accessories HPP */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>HPP</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{accHpp}</label>
                                </div>
                            </div>
                        </div>

                        {/* Accessories In Marketing */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Luar</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{accOutMarketing}</label>
                                </div>
                            </div>
                        </div>

                        {/* Accessories In Marketing */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Dalam</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{accInMarketing}</label>
                                </div>
                            </div>
                        </div>

                        {/* Accessories Discount */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Discount</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{accDiscount}</label>
                                </div>
                            </div>
                        </div>

                        {/* Accessories Designer */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Designer</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{accDesigner}</label>
                                </div>
                            </div>
                        </div>

                        {/* Accessories Drafter */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Drafter</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{accDrafter}</label>
                                </div>
                            </div>
                        </div>

                        {/* Accessories Others */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Lain - lain</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{accOthers}</label>
                                </div>
                            </div>
                        </div>

                        {/* Accessories Profit */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Profit</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <label>{accProfit}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Summary */}
                <div className="mt-4">
                    <div>
                        <span className="font-semibold text-xl">Summary</span>
                        <hr />
                    </div>

                    <div className="mt-4">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 border">
                            <thead className=" text-gray-700 uppercase bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Sales
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Profit
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Margin
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bg-white border-b border-gray-200">
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        Furniture
                                    </th>
                                    <td className="px-6 py-4">
                                        {furSalesPrice === EmptyString ? "0" : furSalesPrice}
                                    </td>
                                    <td className="px-6 py-4">
                                        {furProfit === EmptyString ? "0" : furProfit}
                                    </td>
                                    <td className="px-6 py-4">
                                        {RoundTwoDecimals(calculateMarginFurniture()) + " %"}
                                    </td>
                                </tr>
                                <tr className="bg-white border-b border-gray-200">
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        Civil & Electrical
                                    </th>
                                    <td className="px-6 py-4">
                                        {civSalesPrice === EmptyString ? "0" : civSalesPrice}
                                    </td>
                                    <td className="px-6 py-4">
                                        {civProfit === EmptyString ? "0" : civProfit}
                                    </td>
                                    <td className="px-6 py-4">
                                        {RoundTwoDecimals(calculateMarginCivil()) + " %"}
                                    </td>
                                </tr>
                                <tr className="bg-white border-b">
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        Total
                                    </th>
                                    <td className="px-6 py-4">
                                        {money(calculateTotalSales())}
                                    </td>
                                    <td className="px-6 py-4">
                                        {money(calculateTotalProfit())}
                                    </td>
                                    <td className="px-6 py-4">
                                        
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="mt-5 flex justify-end gap-2">
                <BackButton onClick={backBtnClick} />
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && ( <LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}